// extracted by css-extract-rspack-plugin
export default {"TabPanelRoot":"FilterTabPanel-module__TabPanelRoot___Mo6zH"};